import React from "react";
import BrandLogo from "./BrandLogo";

export default function BrandMarks({ className = "", logoSize = "auto", emblemSize = "auto", plate = false }) {
  const markSize = logoSize !== "auto" ? logoSize : emblemSize;
  const dim = markSize === "auto" ? undefined : (typeof markSize === "number" ? `${markSize}px` : markSize);
  const square = typeof markSize === "number";
  return (
    <div className={`brand-marks ${plate ? "logo-plate" : ""} ${className}`.trim()}>
      <img
        src="/img/ap-emblem.png"
        alt="Government of Andhra Pradesh"
        data-testid="ap-emblem"
        className="ap-state-emblem"
        style={dim ? { width: dim, height: square ? dim : "auto", objectFit: "contain" } : undefined}
      />
      <BrandLogo className="brand-org-logo" testId="apmercl-logo" size={markSize} />
    </div>
  );
}
